module.exports = __webpack_public_path__ + "static/radikal_light-webfont-2e31897973413202d3bf9f8d92b04c91.woff2";